import React from "react";
import { GoogleLogin as OAuthLogin } from "@react-oauth/google";
import "./GoogleLogin.css";
import { analytics } from "../firebase/firebaseClient";
import { logEvent } from "firebase/analytics";

import { db } from "../firebase/firebaseClient";
import { doc, setDoc } from "firebase/firestore";

/**
 * Helper to decode a JWT (Google credential) without external deps.
 * Returns parsed payload or null on error.
 */
const parseJwt = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.warn("Failed to parse JWT", e);
    return null;
  }
};

const GoogleLogin = ({ onLoginSuccess, onLoginFailure }) => {
  const handleSuccess = async (response) => {
    try {
      // Decode user email
      let email = "unknown";
      if (response?.credential) {
        const payload = parseJwt(response.credential);
        email = payload?.email || "unknown";
      }
  
      // Save login instantly (NO await before redirect!)
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("userEmail", email);
  
      // 🔥 Trigger redirect first
      onLoginSuccess?.(response);
  
      // Continue async tasks AFTER redirect (not blocking)
      setTimeout(async () => {
        try {
          const loginTime = new Date().toISOString();
          const sessionId = Date.now().toString();
  
          await setDoc(doc(db, "user_logins", sessionId), {
            email,
            session_id: sessionId,
            login_time: loginTime,
          });
  
          logEvent(analytics, "user_login", {
            email,
            session_id: sessionId,
            login_time: loginTime,
          });
        } catch (e) {
          console.error("Background logging failed:", e);
        }
      }, 10);
  
    } catch (err) {
      console.error(err);
      onLoginFailure?.(err);
    }
  };
  
  

  const handleError = (err) => {
    // optional: log login failure to analytics
    if (typeof window !== "undefined" && analytics) {
      try {
        logEvent(analytics, "user_login_failure", {
          error: err?.toString?.() || "unknown_error",
          time: new Date().toISOString(),
        });
      } catch (e) {
        console.warn("Failed to log analytics event user_login_failure", e);
      }
    }
    if (typeof onLoginFailure === "function") onLoginFailure(err);
  };

  return (
    <div className="google-login-container">
      <div className="login-box">
        <div className="loginheader">
          <h1>Welcome to Haqdarshak</h1>
          <p className="loginsub-header">Every Citizen Matters.</p>
        </div>
        <div className="login-section">
          <p>Please Sign In</p>
          <OAuthLogin onSuccess={handleSuccess} onError={handleError} className="login-button" />
        </div>
      </div>
    </div>
  );
};

export default GoogleLogin;
